
export default {
  props: { tags: { type: Array, default: () => [] } },

  methods: {
    getTagname(tag) {
      return tag.substring(tag.indexOf("_") + 1).replace(/\s/g, "-");
    },
    formatTagLabel(tag, skipSeperator) {
      return (
        tag.substring(tag.indexOf("_") + 1) +
        (this.$route.params.tag && !skipSeperator ? ", " : "")
      );
    },
  },
};
